export const normalizeConsentRenewEmail = (rawData) => {
  return {
    dueDate: rawData?.due_date ?? '',
  }
}
